import { h } from "preact";
import { useState } from "preact/hooks";
import useResizeObserver from '@react-hook/resize-observer';
import { vpReadMoreContainer, vpReadMoreSpan, } from "./ReadMore.css";
import { fontVariant } from "../../styles/index.css";
import { getIsLineClamped } from "../../utils";
var ReadMore = function (_a) {
    var id = _a.id, title = _a.title, titleRef = _a.titleRef, description = _a.description, descriptionRef = _a.descriptionRef, onOpenDetailsHandler = _a.onOpenDetailsHandler, styles = _a.styles, _b = _a.hideOnMissing, hideOnMissing = _b === void 0 ? false : _b;
    var _c = useState(false), showReadMore = _c[0], setShowReadMore = _c[1];
    var calculateSize = function () {
        var isTitleClamped = getIsLineClamped(titleRef === null || titleRef === void 0 ? void 0 : titleRef.current);
        var isDescriptionClamped = getIsLineClamped(descriptionRef === null || descriptionRef === void 0 ? void 0 : descriptionRef.current);
        setShowReadMore(isTitleClamped || isDescriptionClamped);
    };
    useResizeObserver(titleRef, calculateSize);
    useResizeObserver(descriptionRef, calculateSize);
    var descriptionReadMoreStyles = {
        color: styles === null || styles === void 0 ? void 0 : styles.primaryColor,
        fontSize: styles === null || styles === void 0 ? void 0 : styles.descriptionFontSize,
        lineHeight: styles === null || styles === void 0 ? void 0 : styles.descriptionFontSize,
        height: styles === null || styles === void 0 ? void 0 : styles.descriptionFontSize,
    };
    var descriptionFont = (styles === null || styles === void 0 ? void 0 : styles.descriptionFont) || '';
    var handleSeeMoreClick = function () {
        onOpenDetailsHandler({
            id: id,
            description: description,
            title: title,
        });
    };
    if (hideOnMissing && !showReadMore) {
        return null;
    }
    return (h("p", { className: (fontVariant === null || fontVariant === void 0 ? void 0 : fontVariant[descriptionFont]) + " " + vpReadMoreContainer, style: descriptionReadMoreStyles }, showReadMore ? h("span", { className: vpReadMoreSpan, onClick: handleSeeMoreClick }, "See More") : h("span", null, "\u00A0")));
};
export default ReadMore;
